import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/Tx_OrderPlans/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/Tx_OrderPlans/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/Tx_OrderPlans/add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/Tx_OrderPlans/Save',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/Tx_OrderPlans/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/Tx_OrderPlans/Get',
    method: 'get',
    params: { id: id }
  });
}

export function Commit(keyValue) {
  return request({
    url: '/Tx_OrderPlans/Commit',
    method: 'get',
    params: { keyValue }
  });
}

export function getloadfile(data) {
  return request({
    url: '/Tx_OrderPlans/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}

// 退回
export function Back(keyValue) {
  return request({
    url: '/Tx_OrderPlans/Back',
    method: 'get',
    params: { keyValue: keyValue }
  });
}
